import { useState, useEffect, useCallback } from 'react';

type UseMenuFocusProps = {
  isOpen: boolean;
  localValue: string | null;
  acceptedCaseInsensitiveIndex: number;
  suggestionsLength: number;
};

export const useMenuFocus = ({
  isOpen,
  localValue,
  acceptedCaseInsensitiveIndex,
  suggestionsLength,
}: UseMenuFocusProps) => {
  const [menuFocus, setMenuFocus] = useState<number>(0);

  useEffect(() => {
    if (!isOpen) return;
    if (localValue == null) {
      setMenuFocus(0);
    } else if (acceptedCaseInsensitiveIndex >= 0) {
      setMenuFocus(acceptedCaseInsensitiveIndex);
    } else {
      setMenuFocus(suggestionsLength);
    }
  }, [isOpen, localValue, acceptedCaseInsensitiveIndex, suggestionsLength]);

  const handleSuggestionHover = useCallback((index: number) => {
    setMenuFocus(index);
  }, []);

  const handleMouseLeaveMenu = useCallback(() => {
    if (isOpen) {
      setMenuFocus(-1);
    }
  }, [isOpen]);

  return {
    menuFocus,
    setMenuFocus,
    handleSuggestionHover,
    handleMouseLeaveMenu,
  };
};
